import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import HotColumns from "./components/HotColumns";
import LatestUpdates from "./components/LatestUpdates";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryShortcuts />
      <HotColumns />
      <LatestUpdates />
      <SiteIntro />
    </div>
  );
}